import { firstValueFrom } from 'rxjs';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { IWebhookUrls, IPaymentInfo } from '../../models/i-payment-models';
import { PaymentApiService } from '../../../api-services/services/payment-api.service';
import { PAYMENT_PERSON_TYPES, PAYMENT_PLATFORM_TYPES } from '../../payment.constants';
import { IUser } from '../../../users';
import { ngHelper } from '@cakeiteasy/web-utils';
import { PaymentStorageService } from '../../services/payment-storage.service';

@Component({
  standalone: false,
  selector: 'pay-in-store-payment-b',
  templateUrl: './pay-in-store-payment-b.component.html',
  styleUrls: ['./pay-in-store-payment-b.component.scss'],
})
export class PayInStorePaymentBComponent implements OnChanges {
  public PAYMENT_PERSON_TYPES = PAYMENT_PERSON_TYPES;
  public loading: boolean;
  public isValid = false;
  public info: IPaymentInfo;
  public alreadySubscriber = false;

  @Input() public personType: string;
  @Input() public countryCode: string;
  @Input() public user: IUser;
  @Input() public isSharedBusinessAccount = false;
  @Input() public showHeader = true;
  @Input() public webhookUrls: IWebhookUrls;
  @Input() public rejectUrl: string;
  @Input() public giftCardCode: string = null;

  @Output() public onSuccess = new EventEmitter<string>();
  @Output() public onFail = new EventEmitter<any>();
  @Output() public onTermsClick = new EventEmitter<void>();

  @Output() onBusy = new EventEmitter<Promise<any>>();

  constructor(
    private _paymentApi: PaymentApiService,
    private _storage: PaymentStorageService,
  ) {}

  public ngOnChanges(changes: SimpleChanges) {
    const { payInStore } = PAYMENT_PLATFORM_TYPES;
    ngHelper.ifChanged(changes, 'user', (user: IUser, prevUser: IUser) => {
      this.alreadySubscriber = user && user.subscribedOnNews;

      if (user && !this.isSharedBusinessAccount && !prevUser) {
        this._storage.updateContactInfo(payInStore, null, user);
      }
      this.info = this._storage.getContactInfo(payInStore);
    });
  }

  _getPaymentPayload(info: IPaymentInfo, code?: string) {
    const payload = { ...info, code };

    if (this.personType === PAYMENT_PERSON_TYPES.PRIVATE) {
      delete payload.userCompanyName;
    }

    return {
      ...payload,
      ...this.webhookUrls,
    };
  }

  submit() {
    const payload = this._getPaymentPayload(this.info, this.giftCardCode);

    const promise$ = firstValueFrom(this._paymentApi.createPayInStorePayment(payload))
      .then((data) => {
        this.onSuccess.emit(data.sid);
      })
      .catch((err) => {
        this.onFail.emit(err);
      });

    this.onBusy.emit(promise$);
  }

  onInfoUpdated(paymentInfo: IPaymentInfo) {
    const { payInStore } = PAYMENT_PLATFORM_TYPES;
    this.info = { ...this.info, ...paymentInfo };
    this._storage.updateContactInfo(payInStore, this.info);
  }
}
